/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkippedExecutionContractsDto
 */
export interface SkippedExecutionContractsDto {
    /**
     * The ids of the contracts
     * @type {Array<number>}
     * @memberof SkippedExecutionContractsDto
     */
    contractIds?: Array<number>;
}

/**
 * Check if a given object implements the SkippedExecutionContractsDto interface.
 */
export function instanceOfSkippedExecutionContractsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SkippedExecutionContractsDtoFromJSON(json: any): SkippedExecutionContractsDto {
    return SkippedExecutionContractsDtoFromJSONTyped(json, false);
}

export function SkippedExecutionContractsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkippedExecutionContractsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contractIds': !exists(json, 'contractIds') ? undefined : json['contractIds'],
    };
}

export function SkippedExecutionContractsDtoToJSON(value?: SkippedExecutionContractsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contractIds': value.contractIds,
    };
}

